import React from "react";
import {SSOLoader} from "./SSOLoader";

export const SSOSuccess = () => {
    return <SSOLoader />;
};
